export const uploadFileModalDimensions = { width: "450px", height: "75vh" };
export const EXISTING_MODEL_URL_PLACEHOLDER = "existing-model-url-placeholder";
